import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 90vh;
`;

export const Case = styled.div`
  width: 90px;
  height: 90px;
  background-color: var(${(props) => props.color});
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) =>
    props.color === "--lightGreen" || props.color === "--green"
      ? "#555"
      : "var(--mainBgColor)"};
  font-weight: 500;
  font-size: 0.6rem;
  text-align: center;
  cursor: pointer;
  transition: 200ms;

  &:hover {
    box-shadow: 0 0 3px #fff;
  }

  p {
    width: 80px;
    text-transform: uppercase;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  @media ${device.mobileS} and ${device.tablet} {
    width: 40px;
    height: 40px;
    font-size: 0.25rem;
  }

  @media${device.tvL} {
    width: 140px;
    height: 140px;
    font-size: 1rem;

    p {
      width: 110px;
    }
  }

  @media${device.uhd} {
    width: 250px;
    height: 250px;
    font-size: 2rem;

    p {
      width: 230px;
    }
  }
`;

export const CaseDiv = styled.div`
  position: absolute;
  top: 48.5%;
  left: 32%;
  transform: rotate(${(props) => props.$degCaseCalc * props.$index}deg)
    translateX(250px);
  transition: 1s ease;

  @media ${device.mobileS} and ${device.tablet} {
    left: 45%;
    transform: rotate(${(props) => props.$degCaseCalc * props.$index}deg)
      translateX(100px);
    top: 35%;
  }

  @media ${device.laptop} and ${device.laptopMax} {
    top: calc(28.5%);
    left: calc(45%);
  }

  @media ${device.uhd} {
    transform: rotate(${(props) => props.$degCaseCalc * props.$index}deg)
      translateX(600px);
  }
`;

export const Box = styled.div`
  position: absolute;
  left: calc(30.5%);
  top: calc(45%);

  @media ${device.mobileS} and ${device.tablet} {
    left: calc(43%);
    top: calc(34.5%);
  }

  @media ${device.laptop} and ${device.laptopMax} {
    top: calc(28%);
    left: calc(45%);
  }
`;
